document.addEventListener('DOMContentLoaded', () => {
    const selects = document.querySelectorAll('[data-locale-switcher]');

    selects.forEach((select) => {
        select.addEventListener('change', (event) => {
            const target = event.currentTarget;
            const destination = target?.value;

            if (destination) {
                window.location.assign(destination);
            }
        });
    });
});

